/* eslint-disable @typescript-eslint/no-explicit-any */

/** Re-implementation of a basic version of the createGraphiQLFetcher-function from "@graphiql/toolkit" */
export function createGraphiQLFetcher(options: any): any {
  const httpFetch =
    options.fetch || (typeof window !== "undefined" && window.fetch);
  if (!httpFetch) {
    throw new Error("No valid fetcher implementation available");
  }
  options.enableIncrementalDelivery =
    options.enableIncrementalDelivery !== false;
  // simpler fetcher for schema requests
  const simpleFetcher = async (graphQLParams: any, fetcherOpts?: any) => {
    const data = await httpFetch(options.url, {
      method: "POST",
      body: JSON.stringify(graphQLParams),
      headers: {
        "content-type": "application/json",
        ...options.headers,
        ...fetcherOpts?.headers,
      },
    });
    return data.json();
  };

  return async (graphQLParams: any, fetcherOpts: any) => {
    return simpleFetcher(graphQLParams, fetcherOpts);
  };
}
